export default function addExtraZero(value) {
  const numberToCheck = value.toString().split('.');

  if (numberToCheck.length === 1 || numberToCheck[1].length === 2) {
    return value;
  }

  return `${value}0`;
}
